import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n\n  @media print {\n    background-color: transparent;\n    height: auto;\n    min-height: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { color } from '@scp/ui-shared/theme/variables';
import Div100vh from 'react-div-100vh';
export var FullscreenLayoutBase = styled(Div100vh)(_templateObject(), color.backgroundSecondary);